import { Box } from '@mui/material'
import React from 'react'
import { PercentileBarColorOptions } from './Bar'
import { PercentileChartElementBarColors } from 'components/ReportElement'

type DividerColorType = {
  primaryInside: string[]
  primaryOutside: string[]
  secondaryInside: string[]
  secondaryOutside: string[]
  staticInside: string[]
  staticOutside: string[]
  primaryTanInside: string[]
  primaryTanOutside: string[]
  secondaryGreenInside: string[]
  secondaryGreenOutside: string[]
}

const DividerColors: DividerColorType = {
  primaryInside: ['#FFFFFF', PercentileChartElementBarColors.primary],
  primaryOutside: ['#BDBDBD', '#F5F5F5'],
  secondaryInside: ['#FFFFFF', PercentileChartElementBarColors.secondary],
  secondaryOutside: ['#BDBDBD', '#F5F5F5'],
  staticInside: ['#FFFFFF', PercentileChartElementBarColors.static],
  staticOutside: ['#BDBDBD', '#F5F5F5'],
  primaryTanInside: ['#FFFFFF', PercentileChartElementBarColors.primaryTan],
  primaryTanOutside: ['#BDBDBD', '#F5F5F5'],
  secondaryGreenInside: [
    '#FFFFFF',
    PercentileChartElementBarColors.secondaryGreen,
  ],
  secondaryGreenOutside: ['#BDBDBD', '#F5F5F5'],
}

interface Props {
  barPercentage: number
  dividerPercentage: number
  color: PercentileBarColorOptions
}

const PercentileChartElementBarDivider: React.FC<Props> = ({
  barPercentage,
  dividerPercentage,
  color,
}) => {
  let selector: keyof DividerColorType = `${color}Outside`
  if (barPercentage > dividerPercentage) {
    selector = `${color}Inside`
  }
  const colors = DividerColors[selector]
  const dividerSx = {
    position: 'absolute',
    width: '2px',
    background: `repeating-linear-gradient(${colors[0]}, ${colors[0]} 5px, ${colors[1]} 5px, ${colors[1]} 10px)`,
    top: '0',
    bottom: '0',
    zIndex: '1',
  }
  return <Box sx={{ ...dividerSx, left: `${dividerPercentage}%` }}></Box>
}

export default PercentileChartElementBarDivider
